import { createSlice } from "@reduxjs/toolkit";

// Создаем slice (редьюсер + экшены)
const counterSlice = createSlice({
  name: "counter",
  initialState: { value: 0 },
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
  },
});

// Экшены
export const { increment, decrement } = counterSlice.actions;

// // Store
// const store = configureStore({
//   reducer: {
//     counter: counterSlice.reducer,
//   },
// });
export default counterSlice.reducer;
